// @ts-nocheck
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";

/* Store Custom Code - Start */
import merge from "lodash/merge";
/* Store Custom Code - End */

/** buttonSizeVariants
 * ------------------------------------------------------------------------------------------
 * height: Height applied as "min-height" (px)
 * fontSize: Font size (px)
 * padding: CSS applied to the padding property "padding: [VALUE];"
 * icon: Icon size (px)
 * iconPadding: Spacing between the icon and the text (px)
 */

merge(buttonSizeVariants, {
    small: {
        height: 32,
        fontSize: 14,
        icon: 20,
        iconPadding: 23,
    },
    medium: {
        fontSize: 16,
        icon: 24,
        iconPadding: 28,
    },
    large: {
        icon: 28,
        iconPadding: 32,
    },
});
